export default __webpack_public_path__ + "static/media/uiux2.77208e39.jpg";